import { createFileRoute } from '@tanstack/react-router';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/incidents')({
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
  beforeLoad: ({ context, preload }) => {
    context.validateAppPermission('INCIDENTS', preload);
  },
});
